import { MODAL_NONE } from 'components/Modal/constants';

import { ModalState } from './types';

const initialState: ModalState = {
  type: MODAL_NONE,
  props: {},
};

export default initialState;
